import { AlertDialog, AlertDialogBody, AlertDialogContent, AlertDialogFooter, AlertDialogHeader, AlertDialogOverlay, Button, IconButton, Tooltip, useDisclosure } from "@chakra-ui/react"
import React from "react"
import { FaTrash } from "react-icons/fa"
import PropTypes from 'prop-types'

const ConfirmButton = props => {


    const { isOpen, onOpen, onClose } = useDisclosure()
    const cancelRef = React.useRef()
    return (
        <>


            <Tooltip label={props.actionButtonText}>
                <IconButton icon={props.icon} aria-label={props.actionButtonText} size={props.size} colorScheme={props.colorScheme} variant={props.variant} onClick={onOpen} />
            </Tooltip>

            <AlertDialog
                isOpen={isOpen}
                leastDestructiveRef={cancelRef}
                onClose={onClose}
            >
                <AlertDialogOverlay>
                    <AlertDialogContent>
                        <AlertDialogHeader fontSize='lg' fontWeight='bold'>
                        {props.actionButtonText}
                        </AlertDialogHeader>

                        <AlertDialogBody>
                            {props.confirmText}
                        </AlertDialogBody>

                        <AlertDialogFooter>
                            <Button ref={cancelRef} onClick={onClose} >
                                Cancel
                            </Button>
                            <Button colorScheme='red' onClick={() => props.handleAction()} ml={3} >
                                {props.actionButtonText}
                            </Button>
                        </AlertDialogFooter>
                    </AlertDialogContent>
                </AlertDialogOverlay>
            </AlertDialog>
        </>
    )
}

ConfirmButton.propTypes = {
    handleAction: PropTypes.any,
    size: PropTypes.string,
    icon: PropTypes.any,
    buttonTitle: PropTypes.string,
    confirmText: PropTypes.string,
    actionButtonText: PropTypes.string,
    colorScheme: PropTypes.string,
    variant: PropTypes.string
}

export default ConfirmButton
